export class Fichier {
    static jsonMap = {
        base64: { key: 'base64', optional: true, default: '' },
        nom: { key: 'nom', optional: true, default: '' }
    };

    base64: string;
    nom: string;
}
